import { render, staticRenderFns } from "./OrderPlaced.vue?vue&type=template&id=7cd311c4&scoped=true&"
import script from "./OrderPlaced.vue?vue&type=script&lang=js&"
export * from "./OrderPlaced.vue?vue&type=script&lang=js&"
import style0 from "./OrderPlaced.vue?vue&type=style&index=0&id=7cd311c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd311c4",
  null
  
)

export default component.exports